import { render } from "./Packages.vue?vue&type=template&id=18580bb1&scoped=true"
import script from "./Packages.vue?vue&type=script&lang=js"
export * from "./Packages.vue?vue&type=script&lang=js"

import "./Packages.vue?vue&type=style&index=0&id=18580bb1&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-18580bb1"

export default script